import { signIn as amplifySignIn, signInWithRedirect as amplifySignInWithRedirect } from "aws-amplify/auth";

export async function signIn({ email, password }: { email: string; password: string }): Promise<void> {
  await amplifySignIn({ username: email, password });
}

export async function signInWithRedirect(args?: { returnTo?: string; idpIdentifier?: string }): Promise<void> {
  if (args?.idpIdentifier) {
    await amplifySignInWithRedirect({ provider: { idpIdentifier: args.idpIdentifier } });
  } else {
    await amplifySignInWithRedirect({ provider: "Google" });
  }
}
